import React from "react";
import { CalculateStore } from "../../stores/calculateStore";
import { UiFlagsStore } from "../../stores/uiFlagsStore";
import { inject, observer } from "mobx-react";

interface ExceededProxiesInfoProps {
  calculateStore?: CalculateStore;
  uiFlagsStore?: UiFlagsStore;
}

@inject("uiFlagsStore", "calculateStore")
@observer
export default class ExceededProxiesInfo extends React.Component<ExceededProxiesInfoProps> {

  public render() {
    return <div className="proxies-exceeded-info">
      <div className="background" />
      <div className="label">
        {this.props.uiFlagsStore!.isDirect ? this.getDirectLabel() : this.getAgentLabel()}
      </div>
    </div>;
  }

  private getAgentLabel() {
    const exceededProxiesSobolLabel = "* Zawarcie umowy ubezpieczenia wymaga akceptacji Zespołu Underwritingu (przekroczenie pełnomocnictw SU i zniżek - skontaktuj się z menagerem sprzedaży)";
    return `${exceededProxiesSobolLabel}`;
  }

  private getDirectLabel() {
    return <>
      <div>* W celu zawarcia umowy ubezpieczenia skontaktuj się z nami pod numerem <a
        href="tel:+48225345609">22 534 56 09</a></div>
      <div>i podaj nr
        kalkulacji: <span>{this.props.calculateStore!.calculationResponse?.calculationId}</span>
      </div>
    </>;
  }

}
